import React, { Suspense, lazy } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./SponsorThankYouSection.css";


const SignUpForm = lazy(() => import("../SignUpForm/SignUpForm"));

const SponsorThankYouSection = ({ webpageData }) => {
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
  const sponsors = webpageData?.sponsorSection?.sponsors || [];

  return (
    <div className="sponsor-thankyou-section">
      <div className="sponsor-thankyou-div">
            <p className="sponsor-thankyou-div-text">Thank You to Our Sponsors</p>
         </div>
      <Container>

        <p className="sponsor-thankyou-message custom-thankyou-changes">
          We would like to express our deepest gratitude to all of our sponsors for making this event possible.
          Your unwavering support helped turn this vision into reality. Together, we're pushing the boundaries of
          what's possible and setting the stage for groundbreaking advancements in AI and cryptocurrency.
        </p>
        <Row className="sponsor-logo-row justify-content-center">
          {sponsors.map((sponsor, idx) => (
            <Col xs={4} sm={3} md={3} lg={3} className="sponsor-logo-col" key={idx}>
              <a href={sponsor.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={imgCDNURL + sponsor.src}
                  alt={sponsor.alt}
                  className="sponsor-logo-img"
                  loading="lazy"
                />
              </a>
            </Col>
          ))}
        </Row>
      </Container>

      <div className="sponsor-thankyou-newchanges">
      <div className="attendee-thankyou-div">
            <p className="attendee-thankyou-div-text">Thank You to All Attendees</p>
         </div>
        <Container>
          <p className="sponsor-thankyou-message custom-thankyou-changes">
            Thank you for your engagement, your passion, and your dedication to being a part of this historic moment. Your presence and contributions turned this event into more than just a conference—it became a launchpad for the future of Ai, blockchain, and business innovation in the U.S.
          </p>

          <p className="sponsor-thankyou-message">
            Let’s keep the conversation going—this is just the beginning. We’re already looking forward to the next opportunity to unite, innovate, and drive the future of Ai and crypto forward.
          </p>
          {/* <hr className="sponsor-thankyou-hr"></hr>
          <p className="sponsor-thankyou-message">
          To all attendees, thank you for showing up with curiosity and conviction. Your energy made this event more than a summit — it became a launchpad for change.<br/>We’ll keep the conversation going.<br/>Post your memories on social media and tag AngelAi. We will share it on this site.
          </p> */}
        </Container>
      </div>

      <Container>
        <div className="sponsor-thankyou-somechanges">
          <Suspense fallback={<div />}>
            <SignUpForm />
          </Suspense>
        </div>

      </Container>
    </div>
  );
};

export default SponsorThankYouSection;
